import { Component, ViewChild, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatStepper } from '@angular/material/stepper';
import { Categories, Results } from 'src/models/interfaces';
import { QuestionnaireService } from 'src/services/questionnaire.service';
import { QuestionnaireAnimations } from 'src/screens/questionnaire/questionnaire.animations';
import { ResultService } from 'src/services/results.service';
import { DatabaseService } from 'src/services/db.service';
import { Result } from 'src/models/models';

@Component({
	selector: 'app-questionnaire',
	templateUrl: './questionnaire.component.html',
	styleUrls: ['./questionnaire.component.scss'],
	animations: QuestionnaireAnimations,
})
export class QuestionnaireComponent implements OnInit {

	@ViewChild('stepper') private myStepper: MatStepper;

	public selectedCategory: Categories;
	public questionnaire: Categories[];
	public results: Results;
	public selectedCategoryIndex = 0;
	public isLoading = false;

	private queryData: {
		userId: string,
		name: string,
		email: string,
		businessActivity: number,
	}

	constructor(
		private route: ActivatedRoute,
		private qstSrv: QuestionnaireService,
		private rsltSrv: ResultService,
		private dbSrv: DatabaseService,
		private router: Router
	) {
	}

	ngOnInit() {
		this.route.queryParams.subscribe(params => {
			if(params.data === undefined || params.data.userId === ''){
				this.router.navigate(['/user']);
			}else{
				console.log('https://economia-circular.web.app/questionnaire?data='+btoa(JSON.stringify(
					{
						userId: 'qMRc19tpjMyjEVCw1kXT',
						name: 'OSCAR ALBERTO ROMAN GALAVIZ',
						email: 'oroman@cronimetmexico.com',
						businessActivity: 3,
					}
				)));
				this.queryData = JSON.parse(atob(params.data));
				const newResults = this.qstSrv.newResults(this.queryData.userId, this.queryData.businessActivity);
				this.questionnaire = newResults.questionnaire;
				this.results = newResults.results;
				this.selectedCategory = this.questionnaire[0];
			}
		});
	}

	showCategory(categorySelected: Categories) {
		this.myStepper.selectedIndex = 0;
		this.selectedCategoryIndex = this.questionnaire.indexOf(categorySelected);
		return this.selectedCategory = categorySelected;
	}

	formatLabel(value: number) {
		return '  ';
	}

	changeModule() {
		if (this.selectedCategory.id == 'A' || (this.selectedCategory.id == 'B' && this.questionnaire.length == 2)) {
			this.showCategory(this.questionnaire[1]);
		} else {
			this.showCategory(this.questionnaire[this.questionnaire.length - 1]);
		}
	}

	selectionChange(event) {
		const stepId = this.myStepper._getStepLabelId(event.selectedIndex);
		const stepElement = document.getElementById(stepId);
		if (stepElement) {
			setTimeout(() => {
				stepElement.scrollIntoView({ block: 'start', inline: 'nearest', behavior: 'smooth' });
			}, 250);
		}
	}

	finish() {
		this.isLoading = true;
		for (let i of this.results.categories) {
			switch(i.id) {
				case "A":
					for (let j of i.subcategories) {
						j.score = this.rsltSrv._subcategoryScore(j);
						switch (j.id) {
							case 3:
							case 4:
							case 5:
							case 6:
								[j.viabilityScore, j.opportunityScore] = this.rsltSrv._getOptionalScores(j);
								break;
							default:
								break;
						}
					}
					break;
				case "B":
					for (let j of i.subcategories) {
						j.score = this.rsltSrv._subcategoryScore(j)
					}
					break;
				case "C":
					for (let j of i.subcategories) {
						j.score = this.rsltSrv._subcategoryScore(j);
						switch(j.id) {
							case 2:
								[j.viabilityScore, j.opportunityScore] = this.rsltSrv._getOptionalScores(j);
								break;
							default:
								break;
						}
					}
					break;
			}
			i.score = this.rsltSrv._getCategoryAverage(i);
		}
		this.results.score = this.rsltSrv._overallScore(this.results);
		const registerResults = new Result(this.queryData.userId, this.results);
		this.dbSrv.add(registerResults).then(
			(document) => {
				const idBase64 = btoa(document.id);
				this.rsltSrv.sendMail(
					'https://economia-circular.web.app/results?data=' + idBase64,
					this.queryData.email,
					this.queryData.name).then(() => {
					this.router.navigate(['/results'], {
						queryParams: {
							data: idBase64
						}
					});
				});

			}
		)

	}
}
